import React, { useState, createContext } from 'react';

/* Set Global States here. */
const defaultState = {
    exitModalOpen: false,
    showExitModal: () => {},
    interstitialModalOpen: false,
    showInterstitialModal: () => {},
    externalUrl: null,
    setExternalUrl: () => {},
    modalTrigger: null,
    setModalTrigger: () => {},
    textZoom: false,
    setTextZoom: () => {},
    currentVideo: null,
    setcurrentVideo: () => {},
    modalProps: {},
    setModalProps: () => {},
};

const AppContext = createContext(defaultState);

const AppProvider = ({ children }) => {
    const [exitModalOpen, showExitModal] = useState(defaultState.exitModalOpen);
    const [interstitialModalOpen, showInterstitialModal] = useState(
        defaultState.interstitialModalOpen
    );
    const [externalUrl, setExternalUrl] = useState(defaultState.externalUrl);
    const [modalTrigger, setModalTrigger] = useState(defaultState.modalTrigger);
    const [textZoom, setTextZoom] = useState(defaultState.textZoom);
    const [currentVideo, setcurrentVideo] = useState(defaultState.currentVideo);
    const [modalProps, setModalProps] = useState(defaultState.modalProps);

    const store = {
        exitModalOpen,
        showExitModal,
        interstitialModalOpen,
        showInterstitialModal,
        externalUrl,
        setExternalUrl,
        modalTrigger,
        setModalTrigger,
        textZoom,
        setTextZoom,
        currentVideo,
        setcurrentVideo,
        modalProps,
        setModalProps,
    };

    return (
        <>
            <AppContext.Provider value={store}>{children}</AppContext.Provider>
        </>
    );
};

export default AppContext;

export { AppProvider };
